import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./App.scss";
import "leaflet/dist/leaflet.css";

import Home from "./pages/Home";
import RootLayout from "./pages/Root";
import { Fragment, Suspense, lazy } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./components/PrivateRoute";
import FallbackSpinner from "./components/FallbackSpinner";
import Loans from "./pages/Loans";
import PropertyLookup from "./pages/PropertyLookup";
import CountyMap from "./pages/CountyMap";
import Dmedashboard from "./pages/dmedashboard";
import DealCalculator from "./pages/DealCalculator";
import CountyTest from "./pages/CountyTest";
import Login from "./pages/index.jsx";
import { AuthProvider } from "./pages/authContext"
import Register from "./pages/Register.jsx";
import CityResearch from "./pages/CityResearch.jsx";
import SkipTrace from "./pages/SkipTrace.jsx";
import RentCast from "./pages/RentCast.jsx";
import ZillowDescriptionFetcher from "./pages/ZillowDescriptionFetcher.jsx";
import Login2 from "./pages/index2.jsx";
import SupportPage from "./pages/index3.js";
import RedirectToLoans from "./pages/RedirectToLoans.js";
import RedirectToInsurance from "./pages/RedirectToInsurance.js";
import ZillowClonePage from "./pages/ZillowClonePage.jsx";
import DealExplorer2 from "./pages/DealExplorer2.jsx";
import OffMarket from "./pages/OffMarket.jsx";
import OffMarketListings from "./pages/OffMarketListings.jsx";
import PropertysOffMarketMap from "./pages/PropertysOffMarketMap.jsx";
import Login3 from "./pages/index3.jsx";
import Dashboard from "./pages/AdminDashboard.jsx";
// import Dashboard from "./pages/AdminDashboard.jsx";

const SignIn = lazy(() => import("./pages/SignIn"));
const SignUp = lazy(() => import("./pages/SignUp"));
const Offers = lazy(() => import("./pages/Offers"));
const Profile = lazy(() => import("./pages/Profile"));
const CreateListing = lazy(() => import("./pages/CreateListing"));
const EditListing = lazy(() => import("./pages/EditListing"));
const Listing = lazy(() => import("./pages/Listing"));
const Category = lazy(() => import("./pages/Category"));
const ErrorPage = lazy(() => import("./pages/Error"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: (
      <Suspense fallback={<FallbackSpinner />}>
        <Login/>
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: "profile",
        element: <PrivateRoute />,
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<FallbackSpinner />}>
                <Profile />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "create-listing",
        element: <PrivateRoute />,
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<FallbackSpinner />}>
                <CreateListing />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "edit-listing/:listingId",
        element: <PrivateRoute />,
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<FallbackSpinner />}>
                <EditListing />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "sign-in",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Login />
          </Suspense>
        ),
      },
      {
        path: "pp",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Login2 />
          </Suspense>
        ),
      },
      {
        path: "admindashboard",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Dashboard />
          </Suspense>
        ),
      },
      {
        path: "privacypolicy",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Login3 />
          </Suspense>
        ),
      },
      {
        path: "insurance",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <RedirectToInsurance />
          </Suspense>
        ),
      },
      {
        path: "support",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <SupportPage />
          </Suspense>
        ),
      },
      {
        path: "sign-up",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <SignUp />
          </Suspense>
        ),
      },
      
      {
        path: "dmedashboard",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Dmedashboard />
          </Suspense>
        ),
      },
      {
        path: "register",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Register />
          </Suspense>
        ),
      },
      {
        path: "category/:categoryName/:listingId",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Listing />
          </Suspense>
        ),
      },
      {
        path: "dealexplorerlegacy",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Offers />
          </Suspense>
        ),
      },
      {
        path: "countytest",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            < CountyTest/>
          </Suspense>
        ),
      },
      {
        path: "welcome",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <CityResearch />
          </Suspense>
        ),
      },
      {
        path: "propertylookup",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <PropertyLookup />
          </Suspense>
        ),
      },
      
      {
        path: "fmrexplorer",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <CountyMap />
          </Suspense>
        ),
      },
      {
        path: "dealcalculator",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <DealCalculator />
          </Suspense>
        ),
      },
      {
        path: "rentcast",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <RentCast />
          </Suspense>
        ),
      },
      {
        path: "offmarket",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <OffMarketListings />
          </Suspense>
        ),
      },
      {
        path: "omm",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <PropertysOffMarketMap />
          </Suspense>
        ),
      },
      {
        path: "newdealexplorer",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <ZillowClonePage />
          </Suspense>
        ),
      },
      // {
      //   path: "admindashboard",
      //   element: (
      //     <Suspense fallback={<FallbackSpinner />}>
      //       <Dashboard />
      //     </Suspense>
      //   ),
      // },
      {
        path: "dealexplorer",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <DealExplorer2 />
          </Suspense>
        ),
      },
      {
        path: "zdf",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <ZillowDescriptionFetcher />
          </Suspense>
        ),
      },
     
      {
        path: "loanportals",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Loans />
            
          </Suspense>
        ),
      },
      {
        path: "skiptrace",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <SkipTrace />
            
          </Suspense>
        ),
      },
      {
        path: "loans",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <RedirectToLoans />
            
          </Suspense>
        ),
      },
      {
        path: "category/:categoryName",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Category />
          </Suspense>
        ),
      },
    ],
  },
]);

function App() {
  return (
    <Fragment>
          <AuthProvider>

      <RouterProvider router={router} />
      </AuthProvider>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </Fragment>
  )
}

export default App;
